import { DeleteWalletRequest } from '@aaa-ncnu-ie/mypolicy-api-billing';

import axios from '../axios';

export interface DeleteFromWalletArgs {
  requestBody: DeleteWalletRequest;
}

export const deleteFromWallet = async ({
  requestBody,
}: DeleteFromWalletArgs) => {
  const { data } = await axios.delete<void>(
    `${import.meta.env.VITE_MYPOLICY_BILLING_API_URL}/v1/wallet`,
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
      data: requestBody,
    }
  );

  return data;
};
